/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { OfferInfoDto } from './offer-info-dto';

export interface OffersChainDto { 
    offersChainStatus?: OffersChainStatusEnum;
    offers?: Array<OfferInfoDto>;
}

export enum OffersChainStatusEnum {
    CreatorDecisionRequired = 'creator_decision_required',
    OfferorDecisionRequired = 'offeror_decision_required',
    Accepted = 'accepted',
    Refused = 'refused'
}




